import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './app/store';
import AppRoutes from './AppRoutes';
import AuthInitializer from './components/AuthInitializer';
import ErrorBoundary from './components/ErrorBoundary';
import WebPushRegistrar from './components/WebPushRegistrar';
import VolksignStripeProvider from './components/billing/VolksignStripeProvider';
// import GlobalLoader from './components/GlobalLoader';

// Debug: Verify store is created
console.log('Store imported:', store);
console.log('Store type:', typeof store);
console.log('Store has dispatch:', store && typeof store.dispatch === 'function');

function App() {
  console.log('App component rendering...');
  
  // Empty for app.volksign.com (domain root). Set PUBLIC_URL only for subdirectory deploys.
  const basename = process.env.PUBLIC_URL || '';
  
  // Verify store is available
  if (!store) {
    console.error('Store is not available!');
    return <div>Error: Redux store is not configured</div>;
  }
  
  console.log('Rendering Provider with store...');
  
  return (
    <Provider store={store}>
      <VolksignStripeProvider>
        <ErrorBoundary>
          <BrowserRouter basename={basename}>
            <AuthInitializer>
              <WebPushRegistrar />
              <AppRoutes />
            </AuthInitializer>
          </BrowserRouter>
        </ErrorBoundary>
      </VolksignStripeProvider>
    </Provider>
  );
}

export default App;
